/**
 * School-session continuity helper.
 *
 * Caches the most-recent school slug a user was operating under so that when
 * the session token expires (401) we can route them back to their branded
 * `/school/<slug>/login` instead of dumping them on the consumer marketing
 * page.
 *
 * Set by:
 *   - `useSchool` hook when a school doc is hydrated
 *   - `SchoolLogin` page on mount (slug is in URL)
 *   - `InviteAccept` page once the invite is fetched
 *
 * Read by:
 *   - `lib/api.js` 401 interceptor
 *
 * Cleared by:
 *   - `lib/api.js` 401 interceptor when the current path is NOT school-scoped
 *     (so a consumer who happens to have a stale slug from an earlier school
 *     visit doesn't keep getting bounced to a school login).
 */
const KEY = 'yukti_last_school_slug';

export function setLastSchoolSlug(slug) {
  if (!slug) return;
  try { localStorage.setItem(KEY, String(slug)); } catch { /* quota / disabled */ }
}

export function getLastSchoolSlug() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function clearLastSchoolSlug() {
  try { localStorage.removeItem(KEY); } catch { /* */ }
}
